import React, { useEffect, useState } from 'react';
// import Carousel from 'react-bootstrap/Carousel';
// import { Link } from 'react-router-dom';
import Footer from './footer';

export default function Blogs() {
  const [state, setState] = useState([]);
  let url = 'https://jsonplaceholder.typicode.com/posts?userId=1';
  let blogData = async () => {
    let datafetch = await fetch(url);
    let data = await datafetch.json();
    setState(data);
  };
  useEffect(() => {
    blogData();
  }, []);
  // console.log(state)
  return (
    <>
      <div className="d-flex justify-content-center mt-4">
        <p
          style={{
            fontWeight: 'bold',
            fontSize: '40px',
            color: 'rgb(54 105 217)',
          }}
        >
          Blogs
        </p>
      </div>

      <div>
        {state.map((ele, i) => {
          return (
            <div className="pt-3">
              <div class="card container">
                <div class="card-body">
                  <h5 class="card-title">{ele.title}</h5>
                  <p class="card-text">{ele.body}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="pt-4">
        <Footer />
      </div>
    </>
  );
}
